<template>
  <div class="speaker-time">
    <h2 class="white--text">{{ title }}</h2>
    <div class="speaker-time-value white--text">{{ formattedTime }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Talartid"
    },
    activeSpeakerId: {
      type: [String, Number],
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      elapsedSeconds: 0,
      timerId: null
    };
  },
  computed: {
    formattedTime() {
      const total = Math.max(0, this.elapsedSeconds);
      const hours = Math.floor(total / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;
      const pad = value => String(value).padStart(2, "0");

      if (hours > 0) {
        return `${hours}:${pad(minutes)}:${pad(seconds)}`;
      }

      return `${pad(minutes)}:${pad(seconds)}`;
    }
  },
  watch: {
    activeSpeakerId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }

        this.resetTimer();

        if (newVal && this.isActive) {
          this.startTimer();
        }
      }
    },
    isActive: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.resetTimer();
          return;
        }

        if (this.activeSpeakerId) {
          this.startTimer();
        }
      }
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    startTimer() {
      this.clearTimer();
      this.timerId = setInterval(() => {
        this.elapsedSeconds += 1;
      }, 1000);
    },
    clearTimer() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    },
    resetTimer() {
      this.clearTimer();
      this.elapsedSeconds = 0;
    }
  }
};
</script>

<style scoped>
.speaker-time {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.speaker-time-value {
  font-size: 1.25rem;
  font-weight: 600;
}
</style>
